var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"history-table-pagination"},[_c('PtPagination',_vm._g(_vm._b({staticClass:"is-background",attrs:{"background":"","layout":"prev, pager, sizes,next","popper-class":"popper__no-arrow"}},'PtPagination',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }